import { EmptyState } from '@tribeplatform/react-ui-kit/EmptyState'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useI18n } from '../../../i18n/index.js'
import { SmartSearchEntityType } from '../../SmartSearch.types.js'

type Props = {
  query: string
  type: SmartSearchEntityType
}

export const NoResults = ({ query, type }: Props) => {
  const { $t } = useI18n()

  return (
    <div className="flex flex-col items-center justify-center pb-10 pt-5 px-8 md:px-24 flex-1 w-full">
      <EmptyState
        icon={
          <div className="rounded-lg drop-shadow-sm border p-3">
            <SvgIcon name="search" size="xl" />
          </div>
        }
        title={$t({
          defaultMessage: 'No results',
          id: 'Generics.NoResults',
        })}
        description={$t(
          {
            defaultMessage:
              '{type, select, ' +
              'posts {No posts found matching {term}} ' +
              'spaces {No spaces found matching {term}} ' +
              'members {No members found matching {term}} ' +
              'externals {No results found in the knowledge base matching {term}} ' +
              'other {Your search {term} did not match any results}}' +
              ' .Try searching for something else.',
            id: 'Search.Result.NoResultsWithTerm',
          },
          {
            type: type || 'null',
            term: `"${query}"`,
          },
        )}
      />
    </div>
  )
}
